<nz-page-header title="Възстановяване на парола"/>
@if (!success) {
  <section class="mb-5 container-lg">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-xl-6">
        <div class="px-3 border rounded-3 shadow bg-light">
          <header class="py-4 mb-4 border-bottom d-flex align-items-center gap-3">
            <nz-logo height="50"/>
            <h1 class="text-muted">Collectoria</h1>
          </header>
          <main>
            <form [formGroup]="form">
              <fieldset class="mb-4">
                <label for="email" class="mb-0 form-label">Електронна поща*</label>
                <input
                  id="email"
                  type="text"
                  formControlName="email"
                  class="form-control"
                  placeholder="Въведете Вашия имейл..."
                  aria-label="Електронна поща"
                  [class.is-valid]="email?.touched && email?.valid"
                  [class.is-invalid]="email?.touched && email?.invalid">
                <p class="invalid-feedback m-0">Задължително поле!</p>
              </fieldset>
            </form>
            @if (!!errorMessage) {
              <div class="pb-4 text-danger">
                {{ errorMessage }}
              </div>
            }
            <button
              (click)="onSubmit()"
              [disabled]="loading"
              class="w-100 mb-4 btn btn-nz-primary">
              @if (loading) {
                <span class="me-2 spinner-border spinner-border-sm"></span>
              }
              <span>Изпрати заявка</span>
            </button>
          </main>
          <footer class="mb-3 pt-3 d-flex justify-content-between border-top">
            <a aria-label="Вход"
               class="btn btn-link text-decoration-none"
               [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.login]">
              Вход
            </a>
            <a aria-label="Забравена парола"
               class="btn btn-link text-decoration-none"
               [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.registration]">
              Регистрация
            </a>
          </footer>
        </div>
      </div>
    </div>
  </section>
} @else {
  <div class="mb-5 container-lg">
    <div class="alert alert-primary rounded-3 shadow">
      <h5>Успешна заявка за възстановяване на парола!</h5>
      <div class="pb-2">
        Имейл с инструкции за възстановяване на паролата беше изпратен до <strong>{{ email?.value }}</strong>.
      </div>
      <div>
        Ако не виждате имейла в основната си поща, моля проверете в папка "Спам" или "Нежелана поща". Ако все още не
        откривате имейла, не се колебайте да се свържете с нашия екип за съдействие.
      </div>
    </div>
  </div>
}
